
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"18.793","cy":"8.16","fill":"#E345FF","r":"6.219"}}),_c('path',{attrs:{"d":"M16.464 9.573H4.536V6.607a5.964 5.964 0 1111.928 0v2.966z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M.76 8.895h19.48v7.672a8 8 0 01-8 8H8.76a8 8 0 01-8-8V8.895z","fill":"#5935DD"}})])
          )
        }
      }
    